import { Image, View } from 'react-native';
import { Text } from '@/components/Text';
import FontAwesome from '@expo/vector-icons/FontAwesome';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { PatientStackParamList } from '@/navigations/PatientStack';
import { TextLink } from '@/components/TextLink';
import theme from '@/config/theme';
import { styles } from './PromotePage.styles';
import { Links } from '@/config/links';

interface PromotePageProps {
  onBookingClick: () => void;
}

export const PromotePage = ({ onBookingClick }: PromotePageProps) => {
  const { navigate } =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  return (
    <View style={styles.wrapper}>
      <View style={styles.row}>
        <View style={styles.leftCol}>
          <View style={styles.appRow}>
            <Image
              source={require('../../assets/appicon/icon-patient.png')}
              style={styles.appIcon}
              resizeMode="contain"
            />
            <Text style={styles.appTitle}> neolexon Aphasie</Text>
          </View>
          <Text style={styles.featureText}>
            <FontAwesome
              size={18}
              color={theme.colors.primary}
              name={'check'}
            />{' '}
            Individuelle <Text>Anpassung durch Therapeut:innen</Text>
          </Text>
          <Text style={styles.featureText}>
            <FontAwesome
              size={18}
              color={theme.colors.primary}
              name={'check'}
            />{' '}
            <Text>Unbegrenztes Üben</Text>
          </Text>
          <Text style={styles.featureText}>
            <FontAwesome
              size={18}
              color={theme.colors.primary}
              name={'check'}
            />{' '}
            <Text>Interaktive Hilfen</Text>
          </Text>
          <Text style={styles.featureText}>
            <FontAwesome
              size={18}
              color={theme.colors.primary}
              name={'check'}
            />{' '}
            Keine <Text>automatische Verlängerung</Text>
          </Text>
          <Text style={styles.featureText}>
            <FontAwesome
              size={18}
              color={theme.colors.primary}
              name={'check'}
            />{' '}
            <Text>
              Nach der Buchung erhalten Sie unsere Rechnung per E-Mail
            </Text>
          </Text>
        </View>
        <View style={styles.rightCol}>
          <PressableNeolexon onPress={onBookingClick}>
            <View style={styles.buyButton}>
              <Text style={styles.buyButtonRow}>
                <FontAwesome
                  size={18}
                  color={theme.colors.white}
                  name={'shopping-cart'}
                />{' '}
                <Text style={styles.buyButtonText}>
                  3 Monate für 223,01 € buchen
                </Text>
              </Text>
            </View>
          </PressableNeolexon>
          <Text style={styles.boldText}>
            Privat Versicherte können eine Kostenübernahme bei Ihrer
            Krankenversicherung vor der Buchung anfragen. Viele private
            Krankenversicherung übernehmen die Kosten für die neolexon
            Aphasie-App. Falls Sie Hilfe benötigen, wenden Sie sich telefonisch
            an uns unter 089 24886 4440.
          </Text>
          <Text style={styles.boldText}>
            Alle Personen, die in Deutschland gesetzlich versichert sind,
            erhalten einen kostenlosen Rezeptcode durch die Krankenkasse und
            lösen diesen{' '}
            <Text style={styles.digaLink} onPress={() => navigate('DigaCodes')}>
              hier
            </Text>{' '}
            ein.
          </Text>
        </View>
      </View>
      <View style={styles.footer}>
        <Text>
          Sie möchten per Überweisung bezahlen?{' '}
          <TextLink href={Links.buyingFormPatient.href}>Hier klicken</TextLink>.
        </Text>
        <Text>
          Alle Preisangaben inkl. 19% Mehrwertsteuer, diese kann je nach Land
          variieren.
        </Text>
        <Text>
          Buchung wird durchgeführt durch Chargebee und Stripe. Mehr Infos{' '}
          <TextLink href={Links.datenschutz.href}>hier</TextLink>.
        </Text>
      </View>
    </View>
  );
};
